export enum EnumAdLoaderTexts {
  LOADING_DATA = 'Stahuji data...',
  PDF_IN_PROGRESS = 'Připravujeme pro vás PDF export...',
  SEARCHING_CARS = 'Hledáme pro vás všechny vozy...',
  SEARCHING_THIRDPARTY_SERVICES = 'Prověřujeme databáze třetích stran, může to trvat až 30 vteřin...',
  PREPARING_PAYMENT = 'Připravujeme Vaši platbu...',
  VERIFYING_PAYMENT = 'Ověřujeme Vaši platbu...',
}
